import { KeyValue } from '@/main/models/common';
import { TimeZoneTypes, TimeZoneActionTypes } from './timeZoneTypes';
import { timeZoneFilterRequest } from '@/main/models/request/timeZone';

export function getTimeZonesUser(request: timeZoneFilterRequest): TimeZoneActionTypes {
  return {
    type: TimeZoneTypes.GET_TIMEZONES_USER,
    payload: {
      request
    }
  };
}

export function saveTimeZonesUser(
  data: KeyValue[] | null,
  isError: boolean,
  errorMessages: string[] | null
): TimeZoneActionTypes {
  return {
    type: TimeZoneTypes.SAVE_TIMEZONES_USER,
    payload: { data, isError, errorMessages }
  };
}

export function resetReducerTimeZonesUser(): TimeZoneActionTypes {
  return {
    type: TimeZoneTypes.RESET_REDUCER_TIMEZONES_USER
  };
}
